import './loading-spinner.less';
import React from 'react';

const LoadingSpinner = () => <div className="loading-spinner">Loading...</div>;

export default LoadingSpinner;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/root/components/loading-spinner.js